import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../common/style.css';
import SideNave from '../common/sidenav';
import TopNav from '../common/topnav';
import 'bootstrap/dist/css/bootstrap.min.css';
import Select from "react-select";
import Loading from "../loading/loading";
import { showImage } from "../http/api";
import { useAuth } from "../http/authcontex";
import { stateList, desigList, createBank, uploadFile, getBankDataByID } from "../http/api";
import { FaAngleDoubleRight, FaRegSave } from 'react-icons/fa';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


export default function AddBank() {

    const authContext = useAuth();
    const [loading, setLoading] = useState(true);
    const [logoPreview, setLogoPreview] = useState(null);
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [activeTab, setActiveTab] = useState(1);
    const { userEmail } = useAuth();

    const location = useLocation();

    const [isSidebarOpen, setIsSidebarOpen] = useState(
        localStorage.getItem('sb|sidebar-toggle') === 'true'
    );

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        localStorage.setItem('sb|sidebar-toggle', !isSidebarOpen);
    };

    // Model MAP
    const [formData, setFormData] = useState({
        id: 0,
        bankName: '',
        bankLogo: '',
        submittedBy: '',
        active: true,
        branch: {
            id: 0,
            branchName: '',
            addressLine1: '',
            addressLine2: '',
            city: '',
            state: '',
            pinCode: '',
            branchManagerName: '',
            phoneNumber: '',
            mobile: '',
            email: '',

            contactPerson: {
                id:0,
                designation: '',
                mobile: '',
                email: '',
                name: ''
            }
        },

        regionalOffice: {
            id: 0,
            addressLine1: '',
            addressLine2: '',
            city: '',
            state: '',
            pinCode: '',
            phoneNumber: '',
            email: ''
        },
        zonalOffice: {
            id: 0,
            addressLine1: '',
            addressLine2: '',
            city: '',
            state: '',
            pinCode: '',
            phoneNumber: '',
            email: ''
        }
    });

    // State options
    const [stateOptions, setStateOptions] = useState([]);
    const [stateRegOptions, setStateRegOptions] = useState([]);
    const [stateZonOptions, setStateZonOptions] = useState([]);

    // City options
    const [cityOptions, setCityOptions] = useState([]);
    const [cityRegOptions, setCityRegOptions] = useState([]);
    const [cityZonOptions, setCityZonOptions] = useState([]);

    // Designation options
    const [desigOptions, setDesigOptions] = useState([]);

    // Fetch State and City Details
    const viewStateDetails = useCallback(() => {
        setLoading(true);
        stateList()
            .then(response => {
                if (response.status === 200) {
                    console.log("response : success ", response.data);
                    const states = response.data;
                    // Transform states and cities for dropdown
                    const stateDropdownOptions = states.map(state => ({
                        value: state.name,
                        label: state.name,
                        cities: state.cities.map(city => ({
                            value: city.name,
                            label: city.name,
                        })),
                    }));

                    setStateOptions(stateDropdownOptions);
                    setStateRegOptions(stateDropdownOptions);
                    setStateZonOptions(stateDropdownOptions);

                    setLoading(false);

                }

            })
            .catch(error => {
                setLoading(false);
                if (error.response && error.response.status === 401) {
                    // If 401 Unauthorized, redirect to login
                    console.error('Unauthorized access, redirecting to login...');
                    authContext.logout()
                    navigate('')
                } else {
                    // Handle other errors
                    console.error('Error fetching state details:', error);
                }
            });
    }, [authContext, navigate]);

    useEffect(() => {
        viewStateDetails();
    }, [viewStateDetails]);

    // Fetch Designation Details
    const viewDesigDetails = useCallback(() => {
        setLoading(true);
        desigList()
            .then(response => {
                if (response.status === 200) {
                    console.log("response : success ", response.data);
                    const desig = response.data;
                    // Transform designations for dropdown
                    const desigDropdownOptions = desig.map(designation => ({
                        value: designation.name,
                        label: designation.name,
                    }));

                    setDesigOptions(desigDropdownOptions);

                    setLoading(false);

                }

            })
            .catch(error => {
                setLoading(false);
                if (error.response && error.response.status === 401) {
                    // If 401 Unauthorized, redirect to login
                    console.error('Unauthorized access, redirecting to login...');
                    authContext.logout()
                    navigate('')
                } else {
                    // Handle other errors
                    console.error('Error fetching designation details:', error);
                }
            });
    }, [authContext, navigate]);

    // useEffect to fetch designations on mount
    useEffect(() => {
        viewDesigDetails();
    }, [viewDesigDetails]);

    // Handle Form Field Value Change
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => {
            const updatedData = { ...prev };
            const keys = name.split(".");
            let temp = updatedData;

            // Traverse and create nested objects if necessary
            for (let i = 0; i < keys.length - 1; i++) {
                if (!temp[keys[i]]) temp[keys[i]] = {};
                temp = temp[keys[i]];
            }

            // Set the value at the last key
            temp[keys[keys.length - 1]] = value;

            return updatedData;
        });
    };

    // Handle State Change for Branch Office
    const handleStateChange = (selectedOption) => {
        handleChange({ target: { name: "branch.state", value: selectedOption.value } });
        handleChange({ target: { name: "branch.city", value: "" } }); // Clear city when state changes

        // Populate city dropdown based on selected state
        setCityOptions(selectedOption.cities || []);
    };

    // Handle City Change for Branch Office
    const handleCityChange = (selectedOption) => {
        handleChange({ target: { name: "branch.city", value: selectedOption.value } });
    };

    // Handle State Change for Regional Office
    const handleStateRegChange = (selectedOption) => {
        handleChange({ target: { name: "regionalOffice.state", value: selectedOption.value } });
        handleChange({ target: { name: "regionalOffice.city", value: "" } }); // Clear city when state changes

        // Populate city dropdown based on selected state
        setCityRegOptions(selectedOption.cities || []);
    };

    // Handle City Change for Regional Office
    const handleCityRegChange = (selectedOption) => {
        handleChange({ target: { name: "regionalOffice.city", value: selectedOption.value } });
    };

    // Handle State Change for Zonal Office
    const handleStateZonChange = (selectedOption) => {
        handleChange({ target: { name: "zonalOffice.state", value: selectedOption.value } });
        handleChange({ target: { name: "zonalOffice.city", value: "" } });
        setCityZonOptions(selectedOption.cities || []);
    };

    // Handle City Change for Zonal Office
    const handleCityZonChange = (selectedOption) => {
        handleChange({ target: { name: "zonalOffice.city", value: selectedOption.value } });
    };

    // Handle Designation Change
    const handleDesigChange = (selectedOption) => {
        handleChange({ target: { name: "branch.contactPerson.designation", value: selectedOption.value } });
    };

    // Handle File Upload
    const handleFileUpload = useCallback(
        (file) => {
            if (!file) {
                console.error("No file selected for upload");
                return;
            }
            const fileFormData = new FormData();
            fileFormData.append("file", file);
            const keyName = `upload_${Date.now()}_${file.name}`;
            fileFormData.append("keyName", keyName);

            setLoading(true); // Set loading state

            uploadFile(fileFormData)
                .then((response) => {
                    if (response.status === 202 || response.status === 200) {
                        setFormData(prev => ({ ...prev, bankLogo: keyName }));
                        // Optionally, you can set a success message here

                        setLoading(false);
                    }
                })
                .catch((error) => {
                    setLoading(false); // Reset loading state
                    if (error.response && error.response.status === 401) {
                        // Handle 401 Unauthorized
                        console.error("Unauthorized access, redirecting to login...");
                        authContext.logout();
                        navigate("");
                    } else {
                        setLoading(false);
                        console.error("Error during file upload:", error);
                        alert("File upload failed! Please try again.");
                    }
                });
        },
        [authContext, navigate]
    );

    // Fetch Bank Details by ID
    const getBankDetailsByID = useCallback((bankId, type) => {
        //setLoading(true); 
        //setLoading(false);
        getBankDataByID(bankId, type)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    const fetchedData = response.data;
                    setFormData(fetchedData);

                    console.log("type " + type);

                    if (type === 'COPY') {
                        console.log("type " + type);
                        // If type is 'COPY', set the id to 0
                        setFormData(prev => ({
                            ...prev,
                            id: 0,
                            branch: {
                                ...prev.branch,
                                id: 0, // Set branch id to 0
                                contactPerson: {
                                    ...prev.branch.contactPerson,
                                    id: 0 // Set contactPerson id to 0
                                }
                            },
                            regionalOffice: {
                                ...prev.regionalOffice,
                                id: 0 // Set regionalOffice id to 0
                            },
                            zonalOffice: {
                                ...prev.zonalOffice,
                                id: 0 // Set zonalOffice id to 0
                            }
                        }));
                    }

                    // Set City Options for Branch
                    const branchStateOption = stateOptions.find(state => state.value === fetchedData.branch.state);
                    if (branchStateOption) {
                        setCityOptions(branchStateOption.cities);
                    }

                    // Set City Options for Regional Office
                    const regionalStateOption = stateRegOptions.find(state => state.value === fetchedData.regionalOffice.state);
                    if (regionalStateOption) {
                        setCityRegOptions(regionalStateOption.cities);
                    }

                    // Set City Options for Zonal Office
                    const zonalStateOption = stateZonOptions.find(state => state.value === fetchedData.zonalOffice.state);
                    if (zonalStateOption) {
                        setCityZonOptions(zonalStateOption.cities);
                    }


                }
            })
            .catch((error) => {
                setLoading(false); // Reset loading state
                if (error.response && error.response.status === 401) {
                    console.error("Unauthorized access, redirecting to login...");
                    authContext.logout();
                    navigate("");
                } else {
                    console.error("Error fetching bank details:", error);
                }
            });
    }, [authContext, navigate, stateOptions, stateRegOptions, stateZonOptions]);

    // Populate form data when editing
    useEffect(() => {
        if (location.state && location.state.bank) {
            const bankId = location.state.bank.bankid;
            setFormData(prev => ({ ...prev, id: bankId }));
            const type = location.state.typ;
            console.log('type dd' + type);
            // Fetch bank details once state options are loaded
            if (stateOptions.length > 0 && stateRegOptions.length > 0 && stateZonOptions.length > 0) {
                getBankDetailsByID(bankId, type);
            }
        }
    }, [location.state, getBankDetailsByID, stateOptions, stateRegOptions, stateZonOptions]);

    //const [selectedFile, setSelectedFile] = useState(null);

    // Handle File Change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        //setSelectedFile(file);
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setLogoPreview(reader.result);
            };
            reader.readAsDataURL(file);
            handleFileUpload(file); // Pass the correct file here
        }
        //setFormData(prev => ({ ...prev, bankLogo: file }));
    };



    // Validation Function
    const validate = (tab) => {
        let validationErrors = {};
        if (tab === 1) {
            if (!formData.bankName) validationErrors.bankName = "Bank Name is required";
            if (!formData.branch.branchName) validationErrors["branch.branchName"] = "Branch Name is required";
            if (!formData.branch.city) validationErrors["branch.city"] = "City is required";
            if (!formData.branch.state) validationErrors["branch.state"] = "State is required";
            if (!formData.branch.pinCode) validationErrors["branch.pinCode"] = "Pincode is required";
            if (!formData.branch.phoneNumber) validationErrors["branch.phoneNumber"] = "Phone Number is required";
            if (!formData.branch.addressLine1) validationErrors["branch.addressLine1"] = "Address Line 1 is required";
            if (!formData.branch.branchManagerName) validationErrors["branch.branchManagerName"] = "Branch Manager Name is required";
            if (!formData.branch.mobile) validationErrors["branch.mobile"] = "Branch Manager Mobile is required";
            if (!formData.branch.email) validationErrors["branch.email"] = "Branch Manager Email is required";
            if (!formData.branch.contactPerson.designation) validationErrors["branch.contactPerson.designation"] = "Contact Person Designation is required";
            if (!formData.branch.contactPerson.mobile) validationErrors["branch.contactPerson.mobile"] = "Contact Person Mobile is required";
            if (!formData.branch.contactPerson.email) validationErrors["branch.contactPerson.email"] = "Contact Person Email is required";
            if (!formData.branch.contactPerson.name) validationErrors["branch.contactPerson.name"] = "Contact Person Name is required";

        } else if (tab === 2) {
            if (!formData.regionalOffice.addressLine1) validationErrors["regionalOffice.addressLine1"] = "Address Line 1 is required";
            if (!formData.regionalOffice.city) validationErrors["regionalOffice.city"] = "City is required";
            if (!formData.regionalOffice.state) validationErrors["regionalOffice.state"] = "State is required";
            if (!formData.regionalOffice.pinCode) validationErrors["regionalOffice.pinCode"] = "Pincode is required";
            if (!formData.regionalOffice.phoneNumber) validationErrors["regionalOffice.phoneNumber"] = "Phone Number is required";
            if (!formData.regionalOffice.email) validationErrors["regionalOffice.email"] = "Email is required";
        } else if (tab === 3) {
            //const zo = formData.zonalOffice;
            if (!formData.zonalOffice.addressLine1) validationErrors["zonalOffice.addressLine1"] = "Address Line 1 is required";
            if (!formData.zonalOffice.city) validationErrors["zonalOffice.city"] = "City is required";
            if (!formData.zonalOffice.state) validationErrors["zonalOffice.state"] = "State is required";
            if (!formData.zonalOffice.pinCode) validationErrors["zonalOffice.pinCode"] = "Pincode is required";
            if (!formData.zonalOffice.phoneNumber) validationErrors["zonalOffice.phoneNumber"] = "Phone Number is required";
            if (!formData.zonalOffice.email) validationErrors["zonalOffice.email"] = "Email is required";
        }
        return validationErrors;
    };

    // Handle Form Submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate(activeTab);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        } else {
            if (activeTab < 3) {
                setActiveTab(activeTab + 1);
                setErrors({});
            } else {
                const submissionData = { ...formData, submittedBy: userEmail };
                try {
                    const response = await createBank(submissionData);
                    if (response.status >= 200 && response.status <= 201) {
                        navigate('/bank', { state: { success: true } });
                    }
                } catch (error) {
                    const errorMessage = typeof error.response?.data?.message === 'string'
                        ? error.response.data.message
                        : JSON.stringify(error.response?.data?.message) || "Error saving data. Please try again.";

                    console.log("errorMessage: ", errorMessage);
                    toast.error(errorMessage, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        style: {
                            border: "3px solid red",
                            borderRadius: "8px",
                            padding: "10px",
                            bottom: "-45px",
                        }
                    });
                    if (error.response && error.response.data) {
                        setErrors(error.response.data);
                    }
                }
            }
        }
    };


    // Handle Tab Change with Validation
    const handleTabChange = (tab) => {
        if (tab < activeTab) {
            setActiveTab(tab);
        } else {
            const validationErrors = validate(tab - 1);
            if (Object.keys(validationErrors).length === 0) {
                setActiveTab(tab);
            } else {
                setErrors(validationErrors);
            }
        }
    };

    const fetchLogoPreview = useCallback(async (logoFileName) => {
        if (logoFileName) {
            try {
                const response = await showImage(logoFileName);
                if (response.status === 200 || response.status === 202) {
                    const blob = new Blob([response.data], {
                        type: response.headers["content-type"],
                    });
                    const imageUrl = URL.createObjectURL(blob);
                    setLogoPreview(imageUrl); // Set the image preview URL
                }
            } catch (error) {
                console.error("Error fetching logo preview:", error);
                setLogoPreview(null); // Fallback to null if there's an error
            }
        }
    }, []);

    // UseEffect to fetch logo preview when editing a bank
    useEffect(() => {
        if (formData.bankLogo) {
            fetchLogoPreview(formData.bankLogo);
        }
    }, [formData.bankLogo, fetchLogoPreview]);


    return (
        <div className={`sb-nav-fixed ${isSidebarOpen ? 'sb-sidenav-toggled' : ''}`}>
            {loading && <Loading />}
            <TopNav toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
            <div id="layoutSidenav">
                <SideNave isSidebarOpen={isSidebarOpen} />
                <div id="layoutSidenav_content">
                    <main>
                        <div className="container-fluid px-4">
                            <br />
                            <h6 className="mt-2">Bank Details</h6>
                            <div className="card mb-4 border-0">
                                <div className="card-body">
                                    <ul className="nav nav-tabs nav-fill">
                                        <li className="nav-item">
                                            <button
                                                type="button"
                                                className={`nav-item nav-link ${activeTab === 1 ? 'active' : ''}`}
                                                onClick={() => handleTabChange(1)}
                                            >
                                                Branch Office
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button
                                                type="button"
                                                className={`nav-item nav-link ${activeTab === 2 ? 'active' : ''}`}
                                                onClick={() => handleTabChange(2)}
                                            >
                                                Regional Office
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button
                                                type="button"
                                                className={`nav-item nav-link ${activeTab === 3 ? 'active' : ''}`}
                                                onClick={() => handleTabChange(3)}
                                            >
                                                Zonal Office
                                            </button>
                                        </li>
                                    </ul>
                                    <form onSubmit={handleSubmit} className="mt-3">
                                        {activeTab === 1 && (
                                            <>
                                                {/* Branch Office Details */}
                                                {/* Bank Name and Branch name Side by Side */}
                                                <div className="row">
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Bank Name</label>
                                                        <input
                                                            type="text"
                                                            name="bankName"
                                                            value={formData.bankName}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                        />
                                                        {errors.bankName && <div className="text-danger">{errors.bankName}</div>}
                                                    </div>
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Branch Name</label>
                                                        <input
                                                            type="text"
                                                            name="branch.branchName"
                                                            value={formData.branch.branchName}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                        />
                                                        {errors["branch.branchName"] && <div className="text-danger">{errors["branch.branchName"]}</div>}
                                                    </div>
                                                </div>

                                                {/* Address Line 1 and Address Line 2 Side by Side */}
                                                <div className="row">
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Address Line 1</label>
                                                        <input
                                                            type="text"
                                                            name="branch.addressLine1"
                                                            value={formData.branch.addressLine1}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                        />
                                                        {errors["branch.addressLine1"] && <div className="text-danger">{errors["branch.addressLine1"]}</div>}
                                                    </div>
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Address Line 2</label>
                                                        <input
                                                            type="text"
                                                            name="branch.addressLine2"
                                                            value={formData.branch.addressLine2}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                        />
                                                    </div>
                                                </div>

                                                {/* State and City Side by Side */}
                                                <div className="row">
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">State</label>
                                                        <Select
                                                            name="branch.state"
                                                            value={stateOptions.find(option => option.value === formData.branch.state) || null}
                                                            onChange={handleStateChange}
                                                            options={stateOptions}
                                                            className="form-control form-control-sm p-0"
                                                            placeholder="Select State"
                                                            isSearchable
                                                        />
                                                        {errors["branch.state"] && <div className="text-danger">{errors["branch.state"]}</div>}
                                                    </div>
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">City</label>
                                                        <Select
                                                            name="branch.city"
                                                            value={cityOptions.find(option => option.value === formData.branch.city) || null}
                                                            onChange={handleCityChange}
                                                            options={cityOptions}
                                                            className="form-control form-control-sm p-0"
                                                            placeholder="Select City"
                                                            isSearchable
                                                            isDisabled={!formData.branch.state}
                                                        />
                                                        {errors["branch.city"] && <div className="text-danger">{errors["branch.city"]}</div>}
                                                    </div>
                                                </div>

                                                {/* Phone Number and Pincode Side by Side */}
                                                <div className="row">
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Phone Number</label>
                                                        <input
                                                            type="text"
                                                            name="branch.phoneNumber"
                                                            value={formData.branch.phoneNumber}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                        />
                                                        {errors["branch.phoneNumber"] && <div className="text-danger">{errors["branch.phoneNumber"]}</div>}
                                                    </div>
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Pincode</label>
                                                        <input
                                                            type="number"
                                                            name="branch.pinCode"
                                                            value={formData.branch.pinCode}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                        />
                                                        {errors["branch.pinCode"] && <div className="text-danger">{errors["branch.pinCode"]}</div>}
                                                    </div>
                                                </div>

                                                {/* Branch Manager Name and Mobile Side by Side */}
                                                <div className="row">
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Branch Manager Name</label>
                                                        <input
                                                            type="text"
                                                            name="branch.branchManagerName"
                                                            value={formData.branch.branchManagerName}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                        />
                                                        {errors["branch.branchManagerName"] && <div className="text-danger">{errors["branch.branchManagerName"]}</div>}
                                                    </div>
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Branch Manager Mobile</label>
                                                        <input
                                                            type="text"
                                                            name="branch.mobile"
                                                            value={formData.branch.mobile}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                        />
                                                        {errors["branch.mobile"] && <div className="text-danger">{errors["branch.mobile"]}</div>}
                                                    </div>
                                                </div>

                                                {/* Branch Manager Email and Upload Logo Side by Side */}
                                                <div className="row">
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Branch Manager Email</label>
                                                        <input
                                                            type="email"
                                                            name="branch.email"
                                                            value={formData.branch.email}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                        />
                                                        {errors["branch.email"] && <div className="text-danger">{errors["branch.email"]}</div>}
                                                    </div>
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Upload Bank Logo</label>
                                                        <input
                                                            type="file"
                                                            name="bankLogo"
                                                            onChange={handleFileChange}
                                                            accept="image/*"
                                                            className="form-control form-control-sm"
                                                        />
                                                        {logoPreview && (
                                                            <div className="mt-3">
                                                                <img
                                                                    src={logoPreview}
                                                                    alt="Logo Preview"
                                                                    style={{
                                                                        width: "150px",
                                                                        height: "auto",
                                                                        border: "1px solid #ccc",
                                                                        borderRadius: "4px",
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="mt-4 mb-4" style={{ borderBottom: "1px solid #ccc" }}></div>
                                                <h6>Contact Person Details</h6>

                                                {/* Contact Person Name and Designation Side by Side */}
                                                <div className="row">
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Name</label>
                                                        <input
                                                            type="text"
                                                            name="branch.contactPerson.name"
                                                            value={formData.branch.contactPerson.name}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                        />
                                                        {errors["branch.contactPerson.name"] && <div className="text-danger">{errors["branch.contactPerson.name"]}</div>}
                                                    </div>
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Designation</label>
                                                        <Select
                                                            name="branch.contactPerson.designation"

                                                            value={desigOptions.find(option => option.value === formData.branch.contactPerson.designation) || null}
                                                            onChange={handleDesigChange}
                                                            options={desigOptions}
                                                            className="form-control form-control-sm p-0"
                                                            placeholder="Select Designation"
                                                            isSearchable
                                                        />
                                                        {errors["branch.contactPerson.designation"] && <div className="text-danger">{errors["branch.contactPerson.designation"]}</div>}
                                                    </div>
                                                </div>

                                                {/* Contact Person Mobile and Email Side by Side */}
                                                <div className="row">
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Mobile</label>
                                                        <input
                                                            type="text"
                                                            name="branch.contactPerson.mobile"
                                                            value={formData.branch.contactPerson.mobile}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                        />
                                                        {errors["branch.contactPerson.mobile"] && <div className="text-danger">{errors["branch.contactPerson.mobile"]}</div>}
                                                    </div>
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Email</label>
                                                        <input
                                                            type="email"
                                                            name="branch.contactPerson.email"
                                                            value={formData.branch.contactPerson.email}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                        />
                                                        {errors["branch.contactPerson.email"] && <div className="text-danger">{errors["branch.contactPerson.email"]}</div>}
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        {activeTab === 2 && (
                                            <>
                                                {/* Regional Office Details */}
                                                <h6>Regional Office Details</h6>

                                                {/* Address Line 1 and Address Line 2 Side by Side */}
                                                <div className="row">
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Address Line 1</label>
                                                        <input
                                                            type="text"
                                                            name="regionalOffice.addressLine1"
                                                            value={formData.regionalOffice.addressLine1}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                        />
                                                        {errors["regionalOffice.addressLine1"] && <div className="text-danger">{errors["regionalOffice.addressLine1"]}</div>}
                                                    </div>
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Address Line 2</label>
                                                        <input
                                                            type="text"
                                                            name="regionalOffice.addressLine2"
                                                            value={formData.regionalOffice.addressLine2}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                        />
                                                    </div>
                                                </div>

                                                {/* State and City Side by Side */}
                                                <div className="row">
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">State</label>
                                                        <Select
                                                            name="regionalOffice.state"
                                                            value={stateRegOptions.find(option => option.value === formData.regionalOffice.state) || null}
                                                            onChange={handleStateRegChange}
                                                            options={stateRegOptions}
                                                            className="form-control form-control-sm p-0"
                                                            placeholder="Select State"
                                                            isSearchable
                                                        />
                                                        {errors["regionalOffice.state"] && <div className="text-danger">{errors["regionalOffice.state"]}</div>}
                                                    </div>
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">City</label>
                                                        <Select
                                                            name="regionalOffice.city"
                                                            value={cityRegOptions.find(option => option.value === formData.regionalOffice.city) || null}
                                                            onChange={handleCityRegChange}
                                                            options={cityRegOptions}
                                                            className="form-control form-control-sm p-0"
                                                            placeholder="Select City"
                                                            isSearchable
                                                            isDisabled={!formData.regionalOffice.state}
                                                        />
                                                        {errors["regionalOffice.city"] && <div className="text-danger">{errors["regionalOffice.city"]}</div>}
                                                    </div>
                                                </div>

                                                {/* Pincode and Phone Number Side by Side */}
                                                <div className="row">
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Pincode</label>
                                                        <input
                                                            type="number"
                                                            name="regionalOffice.pinCode"
                                                            value={formData.regionalOffice.pinCode}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                        />
                                                        {errors["regionalOffice.pinCode"] && <div className="text-danger">{errors["regionalOffice.pinCode"]}</div>}
                                                    </div>
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Phone Number</label>
                                                        <input
                                                            type="text"
                                                            name="regionalOffice.phoneNumber"
                                                            value={formData.regionalOffice.phoneNumber}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                        />
                                                        {errors["regionalOffice.phoneNumber"] && <div className="text-danger">{errors["regionalOffice.phoneNumber"]}</div>}
                                                    </div>
                                                </div>

                                                {/* Email */}
                                                <div className="row">
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Email</label>
                                                        <input
                                                            type="email"
                                                            name="regionalOffice.email"
                                                            value={formData.regionalOffice.email}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                        />
                                                        {errors["regionalOffice.email"] && <div className="text-danger">{errors["regionalOffice.email"]}</div>}
                                                    </div>
                                                    {/* Empty column for alignment */}
                                                    <div className="col-md-6 mb-1"></div>
                                                </div>
                                            </>
                                        )}

                                        {activeTab === 3 && (
                                            <>
                                                {/* Zonal Office Details */}
                                                <h6>Zonal Office Details</h6>

                                                {/* Address Line 1 and Address Line 2 Side by Side */}
                                                <div className="row">
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Address Line 1</label>
                                                        <input
                                                            type="text"
                                                            name="zonalOffice.addressLine1"
                                                            value={formData.zonalOffice.addressLine1}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                        />
                                                        {errors["zonalOffice.addressLine1"] && <div className="text-danger">{errors["zonalOffice.addressLine1"]}</div>}
                                                    </div>
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Address Line 2</label>
                                                        <input
                                                            type="text"
                                                            name="zonalOffice.addressLine2"
                                                            value={formData.zonalOffice.addressLine2}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                        />
                                                    </div>
                                                </div>

                                                {/* State and City Side by Side */}
                                                <div className="row">
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">State</label>
                                                        <Select
                                                            name="zonalOffice.state"
                                                            value={stateZonOptions.find(option => option.value === formData.zonalOffice.state) || null}
                                                            onChange={handleStateZonChange}
                                                            options={stateZonOptions}
                                                            className="form-control form-control-sm p-0"
                                                            placeholder="Select State"
                                                            isSearchable
                                                        />
                                                        {errors["zonalOffice.state"] && <div className="text-danger">{errors["zonalOffice.state"]}</div>}
                                                    </div>
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">City</label>
                                                        <Select
                                                            name="zonalOffice.city"
                                                            value={cityZonOptions.find(option => option.value === formData.zonalOffice.city) || null}
                                                            onChange={handleCityZonChange}
                                                            options={cityZonOptions}
                                                            className="form-control form-control-sm p-0"
                                                            placeholder="Select City"
                                                            isSearchable
                                                            isDisabled={!formData.zonalOffice.state}
                                                        />
                                                        {errors["zonalOffice.city"] && <div className="text-danger">{errors["zonalOffice.city"]}</div>}
                                                    </div>
                                                </div>

                                                {/* Pincode and Phone Number Side by Side */}
                                                <div className="row">
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Pincode</label>
                                                        <input
                                                            type="number"
                                                            name="zonalOffice.pinCode"
                                                            value={formData.zonalOffice.pinCode}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                        />
                                                        {errors["zonalOffice.pinCode"] && <div className="text-danger">{errors["zonalOffice.pinCode"]}</div>}
                                                    </div>
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Phone Number</label>
                                                        <input
                                                            type="text"
                                                            name="zonalOffice.phoneNumber"
                                                            value={formData.zonalOffice.phoneNumber}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                        />
                                                        {errors["zonalOffice.phoneNumber"] && <div className="text-danger">{errors["zonalOffice.phoneNumber"]}</div>}
                                                    </div>
                                                </div>

                                                {/* Email */}
                                                <div className="row">
                                                    <div className="col-md-6 mb-1">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Email</label>
                                                        <input
                                                            type="email"
                                                            name="zonalOffice.email"
                                                            value={formData.zonalOffice.email}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                        />
                                                        {errors["zonalOffice.email"] && <div className="text-danger">{errors["zonalOffice.email"]}</div>}
                                                    </div>
                                                    {/* Empty column for alignment */}
                                                    <div className="col-md-6 mb-1"></div>
                                                </div>
                                            </>
                                        )}

                                        <button type="submit" className="btn btn-sm btn-warning mt-3">
                                            {activeTab < 3 ? (
                                                <>
                                                    Next <FaAngleDoubleRight />
                                                </>
                                            ) : (
                                                <>
                                                    Submit <FaRegSave />
                                                </>
                                            )}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
            {/* ToastContainer */}
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
}
